import { Component, Input, Output, EventEmitter } from '@angular/core';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FlaggedPrecert } from '@cigna/chcp/shared/user-profile-data-access';

@Component({
  selector: 'cigna-precert-detail-list',
  templateUrl: './precert-detail-list.component.html',
  styleUrls: ['./precert-detail-list.component.scss', '../dashboard-tile.scss'],
})
export class PrecertDetailListComponent {
  @Input() isEditable = true;
  @Input() isRestrictedImpersonator = false;
  @Input() isLoading = true;
  @Input() precerts: FlaggedPrecert[] | null = [];
  @Input() flaggedKeys: string[] = [];
  @Input() isFlagTile = false;

  @Output() flag = new EventEmitter();
}
